const LABELS = {
  ORIGIN: 'Filtrar por Origem',
  DESTINATION: 'Filtrar por Destino'
};

export default LABELS;
